import { useState } from 'react';
import { Grid, GridContainerFullHeight, TextInput, Typography } from '@ts/storybook';

import WrapperEntitySelector from '@modules/entitySelector/WrapperEntitySelector';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import Labels, { defaultConfigComponent as LConfigComponent } from '@pages/DataBase/Configuration/Labels/Labels';
import { IForm, TMode } from '@ts/ui-models';

interface IDistributionListFormProps extends IForm {}

const DistributionListForm = ({ values, mode, requiredFields, onCallbackChange }: IDistributionListFormProps) => {
  const [state, setState] = useState({
    channelType: values.channel ? values?.channel?.channelTypeId : null,
  });

  const isViewMode = mode == 'view';

  const handleSelectChannel = channel => {
    let channelId = null;
    let channelTypeId = null;
    if (channel != null) {
      channelId = channel.getID();
      channelTypeId = channel.channelTypeId;
    }
    setState({ channelType: channelTypeId });
    onCallbackChange('channelId')(channelId);
    onCallbackChange('channel')(channel);
  };

  //#region Render
  const _renderForm = () => {
    switch (state.channelType) {
      case 'email':
        return _renderEmail();
      case 'database':
        return _renderDatabase();
      default:
        return null;
    }
  };
  const _renderEmail = () => {
    const userGroups = values.userGroups;
    const searchComponentConfig = () => {
      return {
        component: Labels,
        configComponent: { ...LConfigComponent, where: { restrictedToEntities: 'taUser' } },
      };
    };

    return (
      <Grid container>
        <Grid size={{ xs: 12 }}>
          <WrapperEntitySelector
            label="User Groups"
            value={userGroups}
            onChange={onCallbackChange('userGroups')}
            searchComponent={searchComponentConfig()}
            multiple
            disabled={isViewMode}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <TextInput
            disabled={isViewMode}
            label="Other Addresses"
            value={values.otherAddresses}
            onChangeValue={onCallbackChange('otherAddresses')}
          />
        </Grid>
      </Grid>
    );
  };

  const _renderDatabase = () => {
    return null;
  };
  //#endregion

  const channel = values.channel;
  return (
    <GridContainerFullHeight spacing={2}>
      <Typography variant="h6" text="Distribution List" />
      <TextInput
        label="List Name"
        isReadOnly={isViewMode}
        value={values.name}
        onChangeValue={onCallbackChange('name')}
        required={requiredFields?.includes('name')}
      />
      <WrapperEntitySelector
        label={'Channel'}
        searchComponent={generateSearchEntitySelector('channel')}
        value={channel ? { ...channel, id: values?.channelId } : null}
        onChangeEntity={handleSelectChannel}
        isReadOnly={isViewMode}
        required={requiredFields?.includes('channel')}
      />
      <Grid size={{ xs: 12 }}>{_renderForm()}</Grid>
    </GridContainerFullHeight>
  );
};

export default DistributionListForm;
